// extracted by mini-css-extract-plugin
export default {"root":"eW3_Ey","titleTooltip":"B5H4eC","title":"Oyqx3k","buttons":"ptzUgR","buttonWrapper":"MTSL7E"};